import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useMe } from '@/shared/api/auth'
import { AbilityProvider } from '@/shared/permissions'
import { MainLayout } from '../layouts'

export const Route = createFileRoute('/_auth')({
  component: RouteComponent,
})

function RouteComponent() {
  const { data, isLoading } = useMe()

  return (
    <AbilityProvider roles={data?.roles ?? []} isRolesLoading={isLoading}>
      <MainLayout>
        <Outlet />
      </MainLayout>
    </AbilityProvider>
  )
}
